import { render } from "./CampaignPerformance.vue?vue&type=template&id=9a08cd02&scoped=true"
import script from "./CampaignPerformance.vue?vue&type=script&lang=js"
export * from "./CampaignPerformance.vue?vue&type=script&lang=js"

import "./CampaignPerformance.vue?vue&type=style&index=0&id=9a08cd02&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src3012/src/s3/00/frontend/admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9a08cd02"]])

export default __exports__